import React, { useEffect, useState } from 'react';
import { Container, Grid, Card, CardActions, Button, Typography, Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { COLOR_MAP, LIGHT_COLOR_MAP, DEFAULT_COLOR } from '../constants';

import {
  BatteryChargingFull,
  SignalCellularAlt,
  Thermostat,
  Opacity,
  Sync
} from '@mui/icons-material';

import Device from '../components/DeviceCard';
import Horizontal from "../components/Horizontal";

export default function DevicesListPage() {

  const navigate = useNavigate();

  const [devices, setDevices] = useState([]);

  const [user, setUserState] = useState(() => {
    const saved = localStorage.getItem(`user`);
    return saved ? JSON.parse(saved) : { id: null, name: null, email: null, telephone: null, isAdmin: false };
  });

  const setUser = (newUser) => {
    setUserState(newUser);
    localStorage.setItem(`user`, JSON.stringify(newUser));
  };

  useEffect(() => {
      const saved = localStorage.getItem(`user`);
      if (!saved) {
        const fetchData = async () => {
          try {
            const token = localStorage.getItem('auth_token');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/user/data`, {
              headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.status === 401) {
              localStorage.removeItem('auth_token');
              navigate('/login');
              return;
            }

            const data = await response.json();
            setUser(data);
          } catch (err) {
            console.error("Data fetch error:", err);
          }
        };
        fetchData();
      }
    }, [user.id]);

  useEffect(() => {
    const fetchDevices = async () => {
      const token = localStorage.getItem('auth_token');

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/user/devices`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (response.ok) {
          const data = await response.json();
          setDevices(data);
        }
      } catch (err) {
        console.error("Error fetching devices:", err);
      }
    };

    fetchDevices();
  }, []);



  return (

    <Container maxWidth='xl' sx={{ mt: 4, pb: 10 }}>
      <Typography variant="h5" gutterBottom>Οι συσκεύες μου</Typography>
      <Grid container spacing={2} sx={{ mt: 3 }}>
        {devices.map((device) => (
          <Grid size={{xs: 12, sm: 6, md: 4}}  key={device._id}>
            <Device device={device} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
